import styled from 'styled-components'
import { Tabs } from 'antd'
import { COLORS } from '../../theme'

const StyledTabs = styled(Tabs)`
  width: ${props => (props.width ? props.width : '')};
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 21px;
  .ant-tabs-nav-list {
    border-right: ${props =>
      props.border ? `1px solid ${COLORS.GREY_T_90}` : 'none'};
  }

  .ant-tabs-tab {
    padding: 15px 20px !important;
    margin-top: 0 !important;
    color: ${COLORS.GREY_T_60};

    border-radius: 0 !important;
    border-bottom: 1px solid ${COLORS.GREY_T_90} !important;
  }
  .ant-tabs-tab-active {
    background: ${COLORS.WHITE} !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${props =>
      props.textColor ? props.textColor : COLORS.PRIMARY} !important;
  }
`
export default StyledTabs
